import { ApiController } from 'config';
import { DiscountRequest, EDiscountDemandTypes } from 'interfaces';
import { get, post } from '..';

export type UserNotification = Omit<Partial<DiscountRequest>, 'type'> & {
  id: number;
  type?: string;
  read?: boolean;
};

type UserNotificationsPayload =
  | UserNotification[]
  | { content?: UserNotification[] };

export function isUnread(n: UserNotification): boolean {
  if (typeof n.read === 'boolean') return !n.read;
  if (typeof n.isRead === 'boolean') return !n.isRead;
  return true;
}

export function isDiscountDemandNotification(n: UserNotification): boolean {
  return Object.values(EDiscountDemandTypes).includes(
    n.type as EDiscountDemandTypes,
  );
}

export async function listAllNotifications(): Promise<UserNotification[]> {
  const payload = await get<UserNotificationsPayload>({
    url: `/${ApiController.userNotifications}/by-auth-user`,
  });

  if (Array.isArray(payload)) return payload;

  return payload?.content ?? [];
}

export async function listUnreadDiscountDemandNotifications(): Promise<
  UserNotification[]
> {
  const notifications = await listAllNotifications();

  return notifications.filter(
    (n) => isDiscountDemandNotification(n) && isUnread(n),
  );
}

export async function markAsRead(ids: number[]): Promise<void> {
  if (ids.length === 0) return;
  await post({
    url: `/${ApiController.userNotifications}`,
    body: { notificationIdList: ids },
  });
}

export async function markAllNewDemandRead(): Promise<void> {
  const ids = (await listUnreadDiscountDemandNotifications()).map((n) => n.id);

  await markAsRead(ids);
}
